import React, { useState } from 'react'
import { ChevronRight, ChevronLeft } from '../../assets/icons'
import { PaginationContainer, ArrowButton, Ellipsis, PageButton } from './styled'
import theme from '../../styled/theme'

const Pagination = ({ totalPages = 1, currentPage = 1, onPageChange }) => {
	const getPageNumbers = () => {
		const pages = []

		if (totalPages <= 4) {
			for (let i = 1; i <= totalPages; i++) {
				pages.push(i)
			}
		} else {
			if (currentPage <= 3) {
				pages.push(1, 2, 3, '...', totalPages)
			} else if (currentPage >= totalPages - 2) {
				pages.push(1, '...', totalPages - 2, totalPages - 1, totalPages)
			} else {
				pages.push(1, '...', currentPage, '...', totalPages)
			}
		}
		return pages
	}

	const handlePrevious = () => {
		if (currentPage > 1) {
			onPageChange(currentPage - 1)
		}
	}

	const handleNext = () => {
		if (currentPage < totalPages) {
			onPageChange(currentPage + 1)
		}
	}

	return (
		<PaginationContainer>
			<ArrowButton onClick={handlePrevious} disabled={currentPage === 1}>
				<ChevronLeft
					size={15}
					color={
						currentPage === 1 ? theme.colors.greys.disabledGrey : theme.colors.text.primaryText
					}
				/>
			</ArrowButton>

			{getPageNumbers().map((page, idx) =>
				page === '...' ? (
					<Ellipsis key={`ellipsis-${idx}`}>...</Ellipsis>
				) : (
					<PageButton
						key={page}
						$isActive={currentPage === page}
						onClick={() => onPageChange(page)}
					>
						{page}
					</PageButton>
				)
			)}

			<ArrowButton onClick={handleNext} disabled={currentPage === totalPages}>
				<ChevronRight
					size={15}
					color={
						currentPage === totalPages
							? theme.colors.greys.disabledGrey
							: theme.colors.text.primaryText
					}
				/>
			</ArrowButton>
		</PaginationContainer>
	)
}

export default Pagination
